import React from 'react';
import BarcodeScannerComponent from "react-webcam-barcode-scanner";
import { Redirect } from 'react-router-dom'

function LabelScanner() {

    const [ trackingNumber, setTrackingNumber ] = React.useState();
    const GLSNumber = /([a-zA-z][0-9]||[a-zA-z]{2})\s[0-9]{9}\s/g;
    let width =  window.innerWidth > 500 ? 500 : window.innerWidth;
    width -= 50;

    if (trackingNumber) return <Redirect to={"/search?s=" + trackingNumber} />

    return (<>
        <BarcodeScannerComponent
            width={width}
            height={width}
            onUpdate={(err, result) => {
            if (result) {
                let m = 0;
                if ((m = GLSNumber.exec(result.text)) !== null) {
                    let trackingNumber = m[0];
                    setTrackingNumber(trackingNumber);
                }
            }
            }}
        />
    </>)
}

export default LabelScanner;